var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgLogoApplePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 62.5,
    height: 39.5,
    rx: 2.25,
    stroke: "#000",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.588 13.45c-.551.641-1.432 1.148-2.314 1.075-.11-.867.322-1.79.827-2.359.55-.66 1.514-1.13 2.295-1.166.091.904-.267 1.79-.808 2.45zm.799 1.247c-1.277-.072-2.37.714-2.975.714-.615 0-1.542-.678-2.552-.66-1.313.018-2.534.75-3.204 1.917-1.377 2.332-.358 5.784.973 7.683.652.94 1.432 1.97 2.46 1.934.973-.036 1.359-.624 2.534-.624 1.184 0 1.524.624 2.552.606 1.065-.018 1.735-.94 2.387-1.88.744-1.067 1.047-2.106 1.065-2.16-.018-.019-2.056-.787-2.075-3.1-.018-1.935 1.607-2.857 1.68-2.912-.918-1.337-2.35-1.482-2.845-1.518zm7.372-2.621v14.091h2.221V21.35h3.076c2.81 0 4.783-1.899 4.783-4.646 0-2.748-1.937-4.628-4.71-4.628h-5.37zm2.221 1.844h2.562c1.928 0 3.03 1.012 3.03 2.793 0 1.78-1.102 2.802-3.04 2.802H26.98V13.92zm11.917 12.356c1.395 0 2.69-.696 3.278-1.799h.045v1.69h2.057v-7.014c0-2.034-1.653-3.344-4.196-3.344-2.36 0-4.104 1.329-4.168 3.154h2.002c.165-.867.982-1.437 2.102-1.437 1.359 0 2.12.624 2.12 1.772v.777l-2.772.163c-2.58.154-3.975 1.193-3.975 3 0 1.827 1.441 3.038 3.507 3.038zm.597-1.672c-1.185 0-1.937-.56-1.937-1.42 0-.885.725-1.4 2.111-1.482l2.47-.154v.796c0 1.32-1.139 2.26-2.644 2.26zM47.022 30c2.167 0 3.186-.814 4.076-3.281L55 15.944h-2.258l-2.617 8.325h-.046l-2.616-8.325H45.14l3.764 10.26-.202.623c-.34 1.058-.89 1.465-1.873 1.465-.174 0-.514-.019-.652-.037v1.69c.129.037.68.055.845.055z",
    fill: "#000"
  })));
}

export default SvgLogoApplePay;